export const IMAGE_URL_REPLACEMENT = {
  from: [
    'feed-images-01.s3.ap-south-1.amazonaws.com',
    'feed-images-01.s3.amazonaws.com',
  ],
  to: 'd19dlu1w9mnmln.cloudfront.net',
} as const;
